import axios, { AxiosError, AxiosRequestHeaders, AxiosResponse } from 'axios'

export interface ErrorInterface {
  message: string
  validation_result: string
}

export const httpRequest = <T>({
  data = {},
  getResponse,
  headers = {},
  method,
  onError,
  onSuccess,
  params = {},
  path,
  responseType,
}: {
  data?: Record<string, unknown>
  getResponse?: (data: AxiosResponse) => void
  headers?: AxiosRequestHeaders
  method?:
  | 'GET'
  | 'DELETE'
  | 'HEAD'
  | 'OPTIONS'
  | 'POST'
  | 'PUT'
  | 'PATCH'
  | 'PURGE'
  | 'LINK'
  | 'UNLINK'
  | undefined
  onError?: (data: ErrorInterface) => void
  onSuccess?: (data: T) => void
  params?: Record<string, unknown>
  path?: string
  responseType?:
  | 'arraybuffer'
  | 'blob'
  | 'document'
  | 'json'
  | 'text'
  | 'stream'
  | undefined
}): void => {
  if (method === 'POST' || method === 'PUT') {
    headers['Content-type'] = 'application/json'
  }
  axios({
    method: method,
    url: process.env.REACT_APP_HOST_API + '/' + path,
    params: params,
    data: data,
    headers: headers,
    responseType: responseType,
    withCredentials: true,
  })
    .then((response) => {
      if (onSuccess) onSuccess(response.data)
      if (getResponse) getResponse(response)
    })
    .catch((res: AxiosError<{ error: ErrorInterface }>) => {
      if (onError && res) {
        if (res.response) {
          onError(res.response.data.error)
        } else {
          onError({ message: res.code, validation_result: '' })
        }
      }
    })
}

export interface ResponseInterface {
  message: string
  validation_result: string
}
